export const headers = (headers) => (request) => ({
    ...request,
    headers: {
        ...request.headers,
        ...headers,
    },
});
